import { CognitoAuthClient, type CognitoConfig } from "./cognito";

/** Read the Cognito config from build-time env, or `undefined` when the SPA is
 * built for the offline/demo (no-auth) topology. */
export function readCognitoConfig(): CognitoConfig | undefined {
  const domain = import.meta.env.VITE_COGNITO_DOMAIN?.trim();
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID?.trim();
  if (!domain || !clientId) return undefined;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return {
    domain,
    clientId,
    redirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI?.trim() || `${origin}/auth/callback`,
    logoutUri: import.meta.env.VITE_COGNITO_LOGOUT_URI?.trim() || `${origin}/`,
  };
}

let cached: CognitoAuthClient | null | undefined;

/** Lazily construct (and memoise) the singleton auth client. Returns
 * `undefined` when Cognito is not configured for this build. */
export function getAuthClient(): CognitoAuthClient | undefined {
  if (cached === undefined) {
    const config = readCognitoConfig();
    cached = config ? new CognitoAuthClient(config) : null;
  }
  return cached ?? undefined;
}
